const recommendationsData = (t) => ({
  title: 'Revisa otros de nuestros servicios',
  recommendations: [
    {
      name: 'ordering',
      title: 'Ordering: Anticipa tus órdenes de compra',
      image: '/images/ordering_herov2.webp',
      url: '/ordering',
    },
    {
      name: t('factoring name'),
      title: `${t('Factoring name')}: Anticipa tus facturas`,
      image: '/images/factoring_hero.webp',
      url: '/factoring',
    },
    {
      name: 'confirming',
      title: 'Confirming: Págale a tus proveedores a tiempo y extiende tu plazo',
      image: '/images/confirming_hero.webp',
      url: '/confirming',
    },
    {
      name: 'pronto pago',
      title: 'Pronto pago: Adelanta el pago de tus proveedores',
      image: '/images/pronto_pago_hero.webp',
      url: '/pronto-pago',
    },
    {
      name: 'kobros',
      title: 'Kobros: Optimiza la gestión de tus cuentas por cobrar.',
      image: '/images/kobros_hero.webp',
      url: '/kobros',
    },
  ],
});

const chileSolutionsRecommendations = [
  'factoring',
  'ordering',
  'confirming',
  'pronto pago',
  'kobros',
];

const mexicoSolutionsRecommendations = [
  'factoraje',
  'confirming',
  'pronto pago',
];

const recommendationsDataByCountry = {
  Chile: chileSolutionsRecommendations,
  Mexico: mexicoSolutionsRecommendations,
};

export { recommendationsData, recommendationsDataByCountry };
